/* differ* join connector, 28 Sep 2026.

   Every email capture on the site is the one Shopify form in
   snippets/differ-waitlist-form.liquid. This file takes that form over:
   instead of posting to Shopify, it runs the bot check and hands the address
   to the founder register, which issues the code and emails it.

   The browser never sees a code. The register answers "ok", plus
   "returning" when the address already has a code, and this file shows one
   of two receipts: new signup, or already in.

   Settings live in snippets/differ-join-config.liquid. With the register URL
   blank this file does nothing and the old Shopify form behaves as before,
   which is the switch for going back.

   Inside the founder gate the receipt takes over the whole window: the
   gate's own line and skip link are hidden and one "look around" link
   closes it. */
(function () {
  'use strict';

  var cfg = window.__differJoin || {};
  if (!cfg.api || !cfg.sitekey) return;

  var API = String(cfg.api).replace(/\/+$/, '') + '/api/join';
  var FLAG = 'differFounderIn';
  var TIMEOUT = 20000;
  var turnstileLoad = null;

  function loadTurnstile() {
    if (turnstileLoad) return turnstileLoad;
    turnstileLoad = new Promise(function (resolve, reject) {
      if (window.turnstile) return resolve();
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { turnstileLoad = null; reject(new Error('turnstile_script')); };
      document.head.appendChild(s);
    });
    return turnstileLoad;
  }

  /* One fresh check per submit. Fails closed: no token, no signup. Mostly
     invisible; if Cloudflare wants a click, the box appears under the form. */
  function getToken(form) {
    return loadTurnstile().then(function () {
      return new Promise(function (resolve) {
        var host = document.createElement('div');
        host.className = 'differ-wl__check';
        form.appendChild(host);
        var id = null;
        var done = false;
        function finish(val) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          try { if (id !== null) window.turnstile.remove(id); } catch (e) { /* nothing */ }
          if (host.parentNode) host.parentNode.removeChild(host);
          resolve(val);
        }
        var timer = setTimeout(function () { finish(null); }, TIMEOUT);
        try {
          id = window.turnstile.render(host, {
            sitekey: cfg.sitekey,
            appearance: 'interaction-only',
            callback: function (t) { finish(t); },
            'error-callback': function () { finish(null); },
            'timeout-callback': function () { finish(null); }
          });
        } catch (e) { finish(null); }
      });
    }).catch(function () { return null; });
  }

  function sourceOf(form) {
    var tags = form.querySelector('input[name="contact[tags]"]');
    var m = tags && /(?:^|,)src-([a-z0-9_-]+)/i.exec(tags.value || '');
    return m ? m[1] : 'site';
  }

  function showError(form, msg) {
    var p = form.querySelector('.differ-ch-batch__error');
    if (!p) {
      p = document.createElement('p');
      p.className = 'differ-ch-batch__error';
      p.setAttribute('role', 'alert');
      var field = form.querySelector('.differ-wl__field');
      if (field && field.nextSibling) field.parentNode.insertBefore(p, field.nextSibling);
      else form.appendChild(p);
    }
    p.textContent = msg;
  }

  function clearError(form) {
    var p = form.querySelector('.differ-ch-batch__error');
    if (p) p.textContent = '';
  }

  function setBusy(form, on) {
    var btn = form.querySelector('button[type="submit"]');
    var input = form.querySelector('input[type="email"]');
    form.setAttribute('aria-busy', on ? 'true' : 'false');
    if (btn) btn.disabled = on;
    if (input) input.readOnly = on;
  }

  /* The receipt, built with textContent so nothing in the settings can
     inject markup. returning = this address already had a code. */
  function confirm(form, returning) {
    var titleText = returning ? (cfg.dupTitle || 'Already in.') : (cfg.confirmTitle || "You're in.");
    var bodyText = returning ? cfg.dupBody : cfg.confirmBody;

    var box = document.createElement('div');
    box.className = 'differ-wl__confirm';
    box.setAttribute('role', 'status');
    box.setAttribute('data-differ-wl-confirm', '');
    if (returning) box.setAttribute('data-differ-wl-returning', '');

    var title = document.createElement('p');
    title.className = 'differ-wl__confirm-title';
    title.id = 'DifferConfirm' + Math.random().toString(36).slice(2, 8);
    title.tabIndex = -1;
    title.style.color = cfg.accent || '#F84000';
    title.textContent = titleText;
    box.appendChild(title);

    if (bodyText) {
      var body = document.createElement('p');
      body.className = 'differ-wl__confirm-body';
      String(bodyText).split('\n').forEach(function (line, i) {
        if (i) body.appendChild(document.createElement('br'));
        body.appendChild(document.createTextNode(line));
      });
      box.appendChild(body);
    }

    while (form.firstChild) form.removeChild(form.firstChild);
    form.appendChild(box);
    try { localStorage.setItem(FLAG, '1'); } catch (e) { /* private mode */ }

    /* Inside the gate: the receipt is the whole window now. */
    var gate = form.closest ? form.closest('[data-differ-gate]') : null;
    if (gate) {
      var gBody = gate.querySelector('.differ-gate__body');
      var gSkip = gate.querySelector('[data-differ-gate-skip]');
      if (gBody) { gBody.hidden = true; gBody.style.display = 'none'; }
      if (gSkip) { gSkip.hidden = true; gSkip.style.display = 'none'; }
      gate.setAttribute('aria-labelledby', title.id);

      var close = gate.querySelector('[data-differ-gate-close]');
      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'differ-gate__skip';
      go.textContent = cfg.lookAround || 'Take a look around';
      go.addEventListener('click', function () {
        if (close) close.click();
        else if (gate.parentNode) gate.parentNode.removeChild(gate);
        document.documentElement.classList.remove('differ-gate-open');
      });
      var panel = gate.querySelector('.differ-gate__panel') || gate;
      panel.appendChild(go);
    }
    try { title.focus({ preventScroll: true }); } catch (e) { /* nothing */ }

    /* Everywhere else on the page, the job is done: hide the sticky bar. */
    var bar = document.querySelector('[data-differ-stickybar]');
    if (bar && !bar.contains(form)) {
      bar.classList.remove('is-active');
      document.documentElement.classList.remove('differ-stickybar-on');
      bar.hidden = true;
    }
  }

  function networkMessage() {
    try { if (navigator.onLine === false) return 'You look offline. Reconnect and try again.'; } catch (e) { /* nothing */ }
    return "Couldn't reach us. Check your connection and try again.";
  }

  function submit(form) {
    if (form.getAttribute('aria-busy') === 'true') return;
    var input = form.querySelector('input[type="email"]');
    var email = input ? String(input.value || '').trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(form, "That doesn't look like an email address.");
      if (input) input.focus();
      return;
    }
    clearError(form);
    setBusy(form, true);

    getToken(form).then(function (token) {
      if (!token) throw { msg: "Couldn't confirm you're a person. Reload the page and try again." };
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var t = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT) : null;
      return fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, token: token, source: sourceOf(form) }),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        if (t) clearTimeout(t);
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (res.ok && data && data.ok) return data;
          throw { msg: (data && data.message) || 'Something broke on our end. Try again in a minute.' };
        });
      });
    }).then(function (data) {
      confirm(form, !!(data && data.returning));
    }).catch(function (err) {
      setBusy(form, false);
      showError(form, err && err.msg ? err.msg : networkMessage());
    });
  }

  /* Delegated, capture phase, so it wins over the plain form post and also
     catches forms the theme editor re-renders. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('differ-wl')) return;
    e.preventDefault();
    try { submit(form); } catch (err) { /* the page must never break on this */ }
  }, true);
})();
